/* HERZBEWEGUNG™ · SAT Akademie · Interaktives Deck
 * Quelle: Originalfolien Nenad Vladović · Korrekturen integriert
 * Theme: Teal-Dark-Green + Gold + Cream
 * Stand: 9 Folien (komplett) */
export const herzbewegungSlides = [
  {
    num: 1,
    type: "cover",
    title: "HERZBEWEGUNG",
    subtitle: "Eine Bewegung für mehr Menschlichkeit, Mitgefühl und Verantwortung.",
    sectionTitle: "DIE WELT VERÄNDERT SICH.",
    sectionLead: "Doch wahre Veränderung beginnt nicht in Systemen. Sie beginnt im Herzen eines Menschen.",
    actions: [
      "Jede freundliche Tat.",
      "Jedes offene Gespräch.",
      "Jeder mutige Schritt.",
      "Jede Entscheidung für Liebe statt Angst.",
    ],
    actionsClosing: "verändert die Welt.",
    rightPanels: [
      {
        title: "WIR GLAUBEN:",
        items: [
          "Jeder Mensch zählt.",
          "Jede Begegnung zählt.",
          "Jeder kleine Schritt zählt.",
          "Jede gute Tat zählt.",
        ],
      },
      {
        title: "HERZBEWEGUNG IST …",
        crossItems: ["keine Partei", "keine Religion", "keine Ideologie"],
        closing: "sondern",
        closingBold: "eine Einladung.",
      },
    ],
    invitation: {
      headline: "Eine Einladung,",
      sub: "mehr Herz in diese Welt zu bringen.",
    },
    bottomBanner: {
      script: "Love is Transformation",
      lineA: "GEH JETZT DEN ERSTEN SCHRITT.",
      sub: "GEMEINSAM FÜR EINE WELT, DIE WIRKLICH MENSCHLICH IST.",
    },
  },

  {
    num: 2,
    type: "content",
    title: "WARUM BRAUCHT DIE WELT EINE HERZBEWEGUNG?",
    titleAccent: "EINE HERZBEWEGUNG",
    lead: "Weil wir an einem Wendepunkt stehen.",
    paragraphs: [
      "Noch nie waren wir so verbunden und doch so getrennt.",
      "Noch nie hatten wir so viele Möglichkeiten und doch so viel Sinnverlust.",
      "Noch nie kannten wir so viel Wissen und doch so wenig Mitgefühl.",
    ],
    conclusion: { plain: "Die Welt braucht jetzt", accent: "nicht mehr – sondern mehr Herz." },
    cardsTitle: "WAS DIE WELT JETZT WIRKLICH BRAUCHT:",
    cards: [
      { h: "VERBINDUNG", t: "Echte Beziehungen, die tragen und heilen.", icon: "heart" },
      { h: "MITGEFÜHL", t: "Ein Herz, das fühlt und nicht wegschaut.", icon: "hands-heart", color: "green" },
      { h: "VERANTWORTUNG", t: "Jeder von uns gestaltet die Welt mit.", icon: "bulb-person", color: "gold" },
      { h: "HOFFNUNG", t: "Die Kraft zu glauben, dass Veränderung möglich ist.", icon: "plant" },
      { h: "MENSCHLICHKEIT", t: "Das Fundament für eine friedliche Zukunft.", icon: "people" },
    ],
    rightPanels: [
      {
        title: "DIE ZEICHEN UNSERER ZEIT",
        iconedItems: [
          { icon: "people", text: "Zunehmende Spaltung statt Miteinander." },
          { icon: "heart-pulse", text: "Einsamkeit und seelischer Druck steigen." },
          { icon: "phone", text: "Ablenkung ersetzt Begegnung." },
          { icon: "plant", text: "Krisen fordern uns auf allen Ebenen." },
          { icon: "globe", text: "Unsere Erde ruft nach Verantwortung." },
        ],
        emphasisHeadline: "ES IST ZEIT, NEU ZU WÄHLEN.",
      },
    ],
    quoteBox: {
      text: "Die Zukunft wird nicht von denen gestaltet, die am lautesten sind, sondern von denen, die am meisten Herz haben.",
      cursive: "Sei du einer von ihnen.",
    },
    bottomBanner: {
      script: "Lasst uns gemeinsam den Wandel sein,",
      lineA: "DEN DIE WELT SO SEHNLICH BRAUCHT.",
    },
  },

  {
    num: 3,
    type: "content",
    title: "DIE EPIDEMIE DER GLEICHGÜLTIGKEIT.",
    titleAccent: "GLEICHGÜLTIGKEIT.",
    lead: "Wenn das Herz verstummt, leidet die Welt.",
    reasons: [
      { kicker: "WIR LEBEN IN GETRENNTEN WELTEN.", text: "Trennung, Misstrauen und Polarisierung nehmen zu.", icon: "heart-broken" },
      { kicker: "WIR VERLIEREN DAS GEFÜHL FÜREINANDER.", text: "Hektik, Druck und digitale Ablenkung machen uns taub.", icon: "person-off" },
      { kicker: "WIR DENKEN ZU KLEIN.", text: "Eigennutz statt Gemeinsinn. Konsum statt Verantwortung.", icon: "globe" },
      { kicker: "WIR SEHEN WEG.", text: "Leid wird übersehen, weil es uns nicht betrifft.", icon: "eye-off" },
      { kicker: "WIR VERGESSEN,", text: "dass jeder Mensch zählt. Dass jede Tat eine Wirkung hat.", icon: "candle" },
    ],
    cardsTitle: "DAS GEGENTEIL VON GLEICHGÜLTIGKEIT IST:",
    cards: [
      { h: "MITGEFÜHL", t: "Einander fühlen. Verstehen. Mittragen.", icon: "heart" },
      { h: "VERBUNDENHEIT", t: "Gemeinsam statt gegeneinander.", icon: "hands-heart", color: "green" },
      { h: "VERANTWORTUNG", t: "Für uns. Für andere. Für die Welt.", icon: "people", color: "gold" },
      { h: "HOFFNUNG", t: "Glauben, dass wir etwas verändern können.", icon: "bulb-person" },
      { h: "LIEBE", t: "Die stärkste Kraft im Universum.", icon: "infinity" },
    ],
    rightPanels: [
      {
        title: "WIR ERKENNEN:",
        goldDots: [
          "Gleichgültigkeit zerstört Verbindung.",
          "Gleichgültigkeit zerstört Vertrauen.",
          "Gleichgültigkeit zerstört Gemeinschaft.",
          "Gleichgültigkeit zerstört Zukunft.",
          "Doch Liebe kann heilen, verbinden und neu erschaffen.",
        ],
      },
    ],
    quoteBox: {
      text: "Keine Krise der Welt lässt sich ohne das Herz lösen.",
      cursive: "Wir brauchen eine Herzbewegung.",
    },
    bottomBanner: {
      script: "Die Welt braucht kein noch grösseres System.",
      lineA: "SIE BRAUCHT EIN GRÖSSERES HERZ.",
      sub: "SEI TEIL DER LÖSUNG. SEI TEIL DER HERZBEWEGUNG.",
    },
  },

  {
    num: 4,
    type: "content",
    title: "DIE MACHT EINER BEGEGNUNG.",
    titleAccent: "EINER BEGEGNUNG.",
    lead: "Ein Moment Menschlichkeit – ein Leben verändert.",
    reasons: [
      { kicker: "EIN LÄCHELN", suffix: "öffnet Herzen.", text: "Es kostet nichts und schenkt unendlich viel.", icon: "smile" },
      { kicker: "ZUHÖREN", suffix: "heilt.", text: "Echte Aufmerksamkeit ist ein Geschenk.", icon: "ear" },
      { kicker: "WERTSCHÄTZUNG", suffix: "verbindet.", text: "Sie macht aus Fremden Freunde.", icon: "handshake" },
      { kicker: "VERSTÄNDNIS", suffix: "überwindet Mauern.", text: "Es schafft Brücken, wo vorher Gräben waren.", icon: "heart" },
      { kicker: "EINE KLEINE GESTE", suffix: "verändert Welten.", text: "Manchmal reicht ein einziger Moment, um Hoffnung zu schenken.", icon: "hand-heart" },
    ],
    cardsTitle: "STELL DIR EINE WELT VOR …",
    cards: [
      { t: "… in der wir einander sehen, statt zu urteilen.", icon: "people" },
      { t: "… in der wir einander stärken, statt zu bekämpfen.", icon: "hands-heart" },
      { t: "… in der wir gemeinsam Lösungen finden.", icon: "people-heart" },
      { t: "… in der Menschlichkeit die Norm ist.", icon: "sparkle-heart" },
      { cursive: true, text: "Diese Welt ist möglich." },
    ],
    rightPanels: [
      {
        title: "WAS EINE BEGEGNUNG BEWIRKEN KANN:",
        iconedItems: [
          { icon: "bulb-person", text: "Sie gibt Halt in schweren Zeiten." },
          { icon: "heart-person", text: "Sie schenkt Mut für neue Wege." },
          { icon: "people-heart", text: "Sie weckt Vertrauen und Zuversicht." },
          { icon: "globe", text: "Sie macht aus einer Welt ein Zuhause." },
        ],
      },
    ],
    quoteBox: {
      cursiveTop: "Jede Begegnung",
      text: "IST EINE CHANCE, DIE WELT EIN STÜCK BESSER ZU MACHEN.",
    },
    bottomBanner: {
      lineA: "JEDE BEGEGNUNG BEGINNT MIT DIR.",
      script: "Sei der Grund für einen besseren Tag — heute.",
    },
  },

  {
    num: 5,
    type: "content",
    title: "DIE KRAFT KLEINER TATEN.",
    titleAccent: "KLEINER TATEN.",
    lead: "Kleine Taten. Grosse Wirkung.",
    paragraphs: [
      "Wir müssen nicht perfekt sein, um die Welt zu verändern.",
      "Wir müssen nur bereit sein, den ersten kleinen Schritt zu gehen.",
    ],
    reasons: [
      { kicker: "EIN LÄCHELN", text: "kann einen schweren Tag erhellen.", icon: "smile" },
      { kicker: "EINE HELFENDE HAND", text: "kann Hoffnung geben.", icon: "hand-heart" },
      { kicker: "EIN OFFENES OHR", text: "kann Einsamkeit lindern.", icon: "speech" },
      { kicker: "EIN KLEINER SCHRITT", text: "kann eine Kette von Veränderung starten.", icon: "plant" },
      { kicker: "EINE GUTE TAT", text: "kann mehr bewirken, als du denkst.", icon: "sun" },
    ],
    chainTitle: "DIE WIRKUNG KLEINER TATEN IST GRÖSSER, ALS WIR DENKEN.",
    chain: [
      { h: "DU TUST", h2: "ETWAS GUTES.", icon: "person" },
      { h: "DU INSPIRIERST", h2: "EINEN MENSCHEN.", icon: "people-heart" },
      { h: "DIESER INSPIRIERT", h2: "WIEDER ANDERE.", icon: "people" },
      { h: "GEMEINSAM VERÄNDERN", h2: "WIR DIE WELT.", icon: "globe-heart" },
    ],
    quoteBox: {
      text: "„Es sind nicht die grossen Helden, die die Welt verändern, sondern Millionen kleiner Menschen, die kleine Dinge tun — mit grosser Liebe.\"",
    },
    beliefBox: {
      lines: [
        "JEDE TAT ZÄHLT.",
        "JEDE GESTE BLEIBT.",
        "JEDE LIEBE VERÄNDERT.",
      ],
      cursive: "Sei ein Teil davon.",
    },
    bottomBanner: {
      script: "Viele kleine Taten. Ein grosses Herz.",
      lineA: "STARTE HEUTE. HIER. JETZT.",
    },
  },

  {
    num: 6,
    type: "content",
    title: "DIE HERZBEWEGUNG — EINE BEWEGUNG FÜR ALLE.",
    titleAccent: "EINE BEWEGUNG FÜR ALLE.",
    lead: "Gemeinsam. Weltweit. Menschlich.",
    leadVariant: "gold-italic",
    paragraphs: [
      "Wir sind keine Organisation. Wir sind eine Bewegung.",
      "Keine Zuschauer. Sondern Mitgestalter.",
      "Keine Helden. Sondern Menschen mit Herz und Haltung.",
    ],
    reasons: [
      { kicker: "VON MENSCHEN", suffix: "für Menschen.", icon: "people" },
      { kicker: "MIT HERZ", suffix: "und Verstand.", icon: "heart" },
      { kicker: "FÜR EINE WELT,", suffix: "in der Liebe die Norm ist.", icon: "globe" },
      { kicker: "FÜR JETZT", suffix: "UND FÜR DIE ZUKUNFT.", icon: "hand-heart" },
    ],
    cardsTitle: "UNSERE 7 PRINZIPIEN — UNSER KOMPASS",
    cards: [
      { h: "LIEBE", t: "ist die Basis.", icon: "heart", color: "gold" },
      { h: "RESPEKT", t: "verbindet.", icon: "hands-heart" },
      { h: "VERANTWORTUNG", t: "gibt Orientierung.", icon: "plant", color: "green" },
      { h: "WERTSCHÄTZUNG", t: "stärkt Beziehungen.", icon: "people-heart" },
      { h: "INTEGRITÄT", t: "schafft Vertrauen.", icon: "compass" },
      { h: "HOFFNUNG", t: "bewegt uns.", icon: "bulb-person", color: "gold" },
      { h: "EINHEIT", t: "macht uns stark.", icon: "globe", color: "gold" },
    ],
    rightPanels: [
      {
        title: "WAS DIE HERZBEWEGUNG IST",
        iconedItems: [
          { icon: "people", text: "Ein globales Netzwerk von Herzmenschen." },
          { icon: "heart", text: "Eine Plattform für Verbindung und Wirkung." },
          { icon: "hands-heart", text: "Eine Kraft für positive Veränderung." },
          { icon: "globe", text: "Ein Zuhause für alle, die die Welt lieben." },
          { icon: "bird", text: "Eine Einladung an dich." },
        ],
      },
    ],
    quoteBox: {
      text: "Alleine können wir so wenig tun. Gemeinsam können wir die Welt verändern.",
      cursive: "Bist du dabei?",
    },
    bottomBanner: {
      script: "Wir sind die Generation, die sich entschlossen hat,",
      lineA: "DIE WELT MIT HERZ NEU ZU GESTALTEN.",
      sub: "SEI TEIL DER HERZBEWEGUNG.",
    },
  },

  {
    num: 7,
    type: "content",
    title: "UNSERE 7 PRINZIPIEN — UNSER KOMPASS.",
    titleAccent: "UNSER KOMPASS.",
    lead: "Sie leiten uns. Sie verbinden uns. Sie verändern die Welt.",
    leadVariant: "gold-italic",
    paragraphs: [
      "Die Herzbewegung basiert auf 7 universellen Prinzipien, die in jedem Menschen wohnen.",
      "Sie sind zeitlos. Sie sind einfach. Und sie haben eine enorme Kraft.",
    ],
    accentParagraph: "Wenn wir sie leben, verändern wir uns selbst. Wenn wir sie teilen, verändern wir die Welt.",
    cardsTitle: "SO LEBEN WIR DIE PRINZIPIEN — JEDEN TAG.",
    cards: [
      { h: "WIR HÖREN ZU.", t: "Wir sehen den Menschen.", icon: "hand-heart" },
      { h: "WIR UNTERSTÜTZEN.", t: "Wir stärken, was gut ist.", icon: "people" },
      { h: "WIR VERBINDEN.", t: "Wir bauen Brücken, keine Mauern.", icon: "handshake" },
      { h: "WIR ERMUTIGEN.", t: "Wir geben Hoffnung und Perspektive.", icon: "plant", color: "green" },
      { h: "WIR WIRKEN.", t: "Gemeinsam für eine bessere Welt.", icon: "globe" },
    ],
    cardsAside: {
      cursive: "Die Prinzipien sind einfach.",
      cursive2: "Ihre Wirkung ist unendlich.",
    },
    rightPanels: [
      {
        title: "UNSERE 7 PRINZIPIEN",
        numberedItems: [
          { n: 1, h: "LIEBE", t: "Wir begegnen jedem Menschen mit Herz.", icon: "heart" },
          { n: 2, h: "RESPEKT", t: "Wir achten die Würde jedes Menschen.", icon: "plant", color: "green" },
          { n: 3, h: "VERANTWORTUNG", t: "Wir übernehmen Verantwortung für unser Denken, Handeln und unsere Welt.", icon: "people" },
          { n: 4, h: "MITGEFÜHL", t: "Wir fühlen mit und handeln aus Mitmenschlichkeit.", icon: "handshake", color: "violet" },
          { n: 5, h: "HOFFNUNG", t: "Wir glauben an die Möglichkeit einer besseren Zukunft.", icon: "bulb-person", color: "gold" },
          { n: 6, h: "EINHEIT", t: "Wir sind verbunden — über Grenzen und Kulturen hinweg.", icon: "globe" },
          { n: 7, h: "INTEGRITÄT", t: "Wir leben nach unseren Werten — echt und ehrlich.", icon: "compass", color: "rose" },
        ],
      },
    ],
    quoteBox: {
      text: "Prinzipien sind wie Sterne. Sie leuchten immer da, wo du hinsiehst.",
      cursive: "Lass sie dein Weg sein.",
    },
    bottomBanner: {
      script: "Ein Kompass fürs Leben. Eine Kraft für die Welt.",
      lineA: "LEBE DIE PRINZIPIEN. SEI DIE VERÄNDERUNG.",
      sub: "GEMEINSAM. MENSCHLICH. JETZT.",
    },
  },

  {
    num: 8,
    type: "content",
    title: "DIE GUTE TATEN CHALLENGE — KLEINE TATEN. GROSSE WIRKUNG.",
    titleAccent: "KLEINE TATEN. GROSSE WIRKUNG.",
    lead: "Jede Tat zählt. Jeder Mensch zählt. Jeder Tag ist eine neue Chance.",
    leadVariant: "gold-italic",
    reasons: [
      { kicker: "EINFACH MITMACHEN", text: "Jeder kann mitmachen. Überall. Jederzeit.", icon: "hand-heart" },
      { kicker: "21 TAGE — 21 GUTE TATEN", text: "Starte eine Challenge. Verändere Gewohnheiten.", icon: "compass" },
      { kicker: "INSPIRIEREN & MOTIVIEREN", text: "Teile deine Taten. Inspiriere andere.", icon: "people-heart" },
      { kicker: "GEMEINSAM MEHR ERREICHEN", text: "Millionen kleine Taten. Ein globaler Wandel.", icon: "globe" },
    ],
    centerCursive: { line1: "Kleine Taten", line2: "verändern", line3: "die Welt." },
    processTitle: "SO FUNKTIONIERT DIE CHALLENGE:",
    processSteps: [
      { h: "ENTSCHEIDE DICH,", h2: "GUTES ZU TUN.", icon: "person" },
      { h: "TUE TÄGLICH", h2: "EINE GUTE TAT.", icon: "compass" },
      { h: "TEILE DEINE TAT", h2: "MIT ANDEREN.", icon: "speech" },
      { h: "INSPIRIERE", h2: "DIE WELT.", icon: "heart" },
      { h: "VERÄNDERE", h2: "DIE ZUKUNFT.", icon: "globe" },
    ],
    processCursive: {
      lines: [
        "Starte heute.",
        "Sei der Grund für ein",
        "Lächeln, Hoffnung",
        "und Veränderung.",
      ],
    },
    rightPanels: [
      {
        title: "IDEEN FÜR GUTE TATEN",
        iconedItems: [
          { icon: "heart", text: "EIN LÄCHELN — Schenke jemandem ein Lächeln." },
          { icon: "cup", text: "EIN DANKESCHÖN — Bedanke dich von Herzen." },
          { icon: "hand-heart", text: "EINE HELFENDE HAND — Hilf jemandem ohne etwas zu erwarten." },
          { icon: "speech", text: "EIN GUTES WORT — Sage etwas, das aufbaut." },
          { icon: "plant", text: "FÜR UNSERE UMWELT — Handle nachhaltig. Schütze unsere Erde." },
          { icon: "people-heart", text: "ZEIT SCHENKEN — Höre zu. Sei da. Verbringe Zeit." },
          { icon: "infinity", text: "VON HERZEN GEBEN — Teile, was du hast. Materiell oder immateriell." },
        ],
      },
    ],
    quoteBox: {
      text: "Die Welt verändert sich nicht durch grosse Worte, sondern durch kleine Taten.",
      cursive: "Sei der Anfang.",
    },
    bottomBanner: {
      script: "Eine gute Tat kann ein Leben verändern.",
      lineA: "VIELE GUTE TATEN KÖNNEN DIE WELT VERÄNDERN.",
      sub: "MACH MIT. INSPIRIER ANDERE. SEI HERZBEWEGUNG.",
    },
  },

  {
    num: 9,
    type: "content",
    title: "HERZBOTSCHAFTER — DIE FUNKEN, DIE DIE WELT ERLEUCHTEN.",
    titleAccent: "DIE FUNKEN, DIE DIE WELT ERLEUCHTEN.",
    lead: "Ein Mensch. Ein Herz. Eine Wirkung.",
    leadVariant: "gold-italic",
    paragraphs: [
      "Herzbotschafter sind Menschen, die die Herzbewegung leben und in die Welt tragen.",
    ],
    accentParagraph: "Sie inspirieren. Sie verbinden. Sie verändern.",
    reasons: [
      { kicker: "MIT HERZ DABEI", text: "Sie leben die Prinzipien und handeln mit Liebe.", icon: "heart" },
      { kicker: "VORBILD & INSPIRATION", text: "Sie zeigen, dass Veränderung möglich und einfach ist.", icon: "people" },
      { kicker: "MULTIPLIKATOREN DES GUTEN", text: "Sie entzünden Funken, die Kreise ziehen.", icon: "globe" },
    ],
    processTitle: "SO WIRST DU HERZBOTSCHAFTER",
    processSteps: [
      { h: "SPÜRE DEN RUF", h2: "in deinem Herzen.", icon: "heart" },
      { h: "SAGE JA", h2: "zur Herzbewegung.", icon: "person" },
      { h: "WIRKE IN DEINEM UMFELD", h2: "— im Kleinen und im Grossen.", icon: "people-heart" },
      { h: "TEILE DEINE ERFAHRUNGEN", h2: "und inspiriere andere.", icon: "speech" },
      { h: "WERDET GEMEINSAM", h2: "ZUR BEWEGUNG.", icon: "globe-heart" },
    ],
    rightPanels: [
      {
        title: "EIN HERZBOTSCHAFTER IST:",
        iconedItems: [
          { icon: "heart", text: "AUTHENTISCH — Er lebt, was er teilt." },
          { icon: "star", text: "MUTIG — Er geht voran, auch wenn es neu ist." },
          { icon: "plant", text: "VERBINDEND — Er bringt Menschen zusammen." },
          { icon: "hand-heart", text: "DIENEND — Er stellt sich in den Dienst des Guten." },
          { icon: "sun", text: "HOFFNUNGSVOLL — Er glaubt an eine bessere Zukunft — und handelt dafür." },
        ],
      },
    ],
    quoteBox: {
      text: "Du musst nicht perfekt sein, um ein Herzbotschafter zu sein. Du musst nur bereit sein, dein Herz zu öffnen und loszugehen.",
      cursive: "Die Welt wartet auf dich.",
    },
    bottomBanner: {
      script: "Jeder Funke zählt. Jede Stimme zählt. Jedes Herz zählt.",
      lineA: "WERDE HERZBOTSCHAFTER.",
      sub: "ZÜNDE LIEBE AN. VERBREITE HOFFNUNG. VERÄNDERE DIE WELT.",
    },
  },
];

export default herzbewegungSlides;
